import React, { useEffect } from "react";
import { Alert } from "antd";

function SetAlert({ alertMessage, setAlertMessage }) {
  const { success, error } = alertMessage;

  useEffect(() => {
    if (error) {
      const errorTimer = setTimeout(() => {
        setAlertMessage((prevMessage) => ({ ...prevMessage, error: "" }));
      }, 2000);

      return () => clearTimeout(errorTimer);
    }
  }, [error, setAlertMessage]);

  useEffect(() => {
    if (success) {
      const successTimer = setTimeout(() => {
        setAlertMessage((prevMessage) => ({ ...prevMessage, success: "" }));
      }, 2000);

      return () => clearTimeout(successTimer);
    }
  }, [success, setAlertMessage]);

  return (
    <>
      {error && (
        <Alert
          type="error"
          message={error}
          showIcon
          style={{ textAlign: "center", marginBottom: 16 }}
        />
      )}
      {success && (
        <Alert
          type="success"
          message={success}
          showIcon
          style={{ textAlign: "center", marginBottom: 16 }}
        />
      )}
    </>
  );
}

export default SetAlert;
